import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProductsComponent } from './products/products.component';
import { OperatorsComponent } from './operators/operators.component';
import { MachinesComponent } from './machines/machines.component';
import { MachineTypesComponent } from './machine-types/machine-types.component';
import { SettingsComponent } from './settings/settings.component';
import { ReportsComponent } from './reports/reports.component';
import { LiveActivityComponent } from './live-activity/live-activity.component';
import { RolesComponent } from './roles/roles.component';
import { roleGuard } from '../guards/role.guard';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'reports', component: ReportsComponent, canActivate: [roleGuard], data: { roles: ['admin', 'supervisor'] } },
  { path: 'live-activity', component: LiveActivityComponent, canActivate: [roleGuard], data: { roles: ['admin', 'supervisor'] } },
  { path: 'products', component: ProductsComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
  { path: 'operators', component: OperatorsComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
  { path: 'machines', component: MachinesComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
  { path: 'machine-types', component: MachineTypesComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
  { path: 'settings', component: SettingsComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
  { path: 'roles', component: RolesComponent, canActivate: [roleGuard], data: { roles: ['admin'] } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
